module.exports = __webpack_public_path__ + "img/ZE-Ready-EV-Ready.ee65a7e6.png";